import React from 'react';

import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Avatar as CustomAvatar } from '../../../../../shared/components/Avatar';
import { useConversations } from '../../hooks';
import { formatDateTime } from '../../utils';

const Skeleton = () => (
  <div className="flex gap-4 p-4 border-b">
    <CustomAvatar.Skeleton size="md" />

    <div className="flex flex-col gap-1 flex-1">
      <ShadcnSkeleton className="h-4 w-32" />
      <ShadcnSkeleton className="h-3 w-24" />
      <ShadcnSkeleton className="h-3 w-48" />
    </div>

    <ShadcnSkeleton className="h-3 w-32 ml-auto" />
  </div>
);

const MessageDetails = () => {
  const { activeConversation, isLoadingActive: isLoading } = useConversations();

  if (isLoading) {
    return <Skeleton />;
  }

  const {
    lastMessage: {
      createdAt: sentAt,
      sender: { email: senderEmail, fullName: senderName, initials: senderInitials },
    },
    subject,
  } = activeConversation;

  return (
    <div className="flex gap-4 p-4 border-b">
      <Avatar className="w-10 h-10">
        <AvatarFallback className="text-sm bg-muted">{senderInitials}</AvatarFallback>
      </Avatar>

      <div className="flex flex-col gap-1">
        <div className="font-semibold text-sm">{senderName}</div>
        <div className="line-clamp-1 text-xs">{subject}</div>

        <div className="text-xs">
          <span className="font-medium">Reply-To:</span> {senderEmail}
        </div>
      </div>

      <div className="ml-auto text-xs text-muted-foreground">
        {formatDateTime(sentAt)}
      </div>
    </div>
  );
};

export default MessageDetails;
